module.exports = __webpack_public_path__ + "static/img/IMG-4147.66821d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/collage/papercuts/IMG-4147.jpg
// module id = isYs
// module chunks = 1